// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Highlight_wrap__4FXPA","hl":"Highlight_hl__Skbt2"};